import { StrictMode, useEffect, useState, useCallback } from 'react';
import { useStore } from './useStore';
import useBackendSync from './useBackendSync';
import useAvailability from './useAvailability';
import useClearOrder from './useClearOrder';
// import useTicket from './useTicket';
// import usePrice from './usePrice';
import useHttp from '../hooks/useHttp';

const useAppData = () => {
  const [state, dispatch] = useStore();
  const { appData, calendarType, clientState, section } = state;
  const { sendRequest } = useHttp();
  const { runResume, postUpdate } = useBackendSync();
  // const { breakAll } = useTicket();
  const { clearOrder } = useClearOrder();
  const { fetchMonth } = useAvailability();
  const [cartElement, setCartElement] = useState(null);


  useEffect(() => {
    // console.log('state', state);
    // console.log('test');
    const endpoint = '/wp-json/wb-tickets/v1/options';
    sendRequest({
      url: endpoint,
      method: 'GET'
    }, processContent);

    window.addEventListener('resize', updateWindowSize());
    return () => window.removeEventListener('resize', updateWindowSize());
  }, []);

  const processContent = (data) => {
    // console.log('APPDATA', data);
    const sectionData = data.ticket_types[data.default_ticket_type.post_name];
    const s = !!section ? section : data.default_ticket_type.post_name;

    dispatch('SET', {
      appData: data
    });
    // console.log('test');
    runResume(sectionData['category_id'], s);
    // setCSSVars(data);
    initTickets(sectionData);

    if (calendarType === 'booking') {
      initBackgroundImage(data.background_image);
      let section = sessionStorage.getItem('section');
      if (section === '') {
        section = data.default_ticket_type.post_name;
        sessionStorage.setItem('section', section);
      }

      const sectionData = data.ticket_types[section];

      dispatch('SET', {
        section: section,
        pageSlug: data.ticketing_page.post_name
      });

      if (!appData.disable_ticketing) {
        setDefault(sectionData);
        initMiniCart(data.minicart_parent_id);
        initApp(sectionData);
      }
    }
  }

  const setDefault = (ticketsData) => {
    // console.log('setDefault', ticketsData);
    let defaults = ticketsData.ticket_classes.filter(d => {
      return d.quantity > 0;
    });
    defaults = defaults.map(d => {
      return {
        id: d.id,
        quantity: parseInt(d.quantity)
      }
    });
    // const addons = ticketsData.addons.map(a => {
    //   a.price = parseFloat(a.price);
    //   return a;
    // })
    let newCsQty = ticketsData.ticket_data.map(t => {
      t.quantity = 0;
      // t.price = parseFloat(t.price);
      return Object.assign(t, defaults.find(t2 => {
        return t2 && t.id === t2.id
      }))
    });
    // console.log('newCsQty', newCsQty);
    // console.log('setDefault defaults', defaults);
    const newCsState = {
      ...clientState,
      cat: ticketsData.category_id,
      iq: ticketsData.addons,
      tq: newCsQty,
      evdate: null,
      evid: null,
      evtime: null
    };
    dispatch('SET', {
      clientState: newCsState
    });
  }

  const updateWindowSize = useCallback(() => {
    dispatch('SET', { wW: window.innerWidth });
  });

  const changeType = (type) => {
    // console.log('changeType', clientState);
    sessionStorage.setItem('section', type);
    const sectionData = appData.ticket_types[type];
    runResume(sectionData['category_id'], type);

    initTickets(sectionData);
    setDefault(sectionData);
    const typeTitle = sectionData['title'].replace(' Tickets', '');
    dispatch('SET', {
      section: type,
      pageTitle: typeTitle + ' Tickets',
      showCalendar: true
    });
    dispatch('RESET_MESSAGES');
    postUpdate();
    if (type !== 'gift-tickets') fetchMonth();
    clearOrder();
  }

  const initTickets = (tour) => {
    // console.log('initTickets');
    let ticketsWithAddons = tour.ticket_classes.concat(tour.addons);
    ticketsWithAddons = ticketsWithAddons.map(t => {
      t.price = parseFloat(t.price);
      t.quantity = (calendarType === 'booking') ? parseInt(t.quantity) : 0;
      return t;
    });
    dispatch('SET', {
      tickets: ticketsWithAddons,
      fares: tour.ticket_data,
    });
  }

  const initApp = (tour) => {
    // console.log('initApp');
    const addOnCheck = tour.addons.length;

    dispatch('SET', {
      hasAddons: addOnCheck > 0,
      stepNames: addOnCheck > 0 ? ['Home', 'Tickets', 'Add-Ons', 'Checkout'] : ['Home', 'Tickets', 'Checkout'],
      lastStep: addOnCheck > 0 ? 3 : 2
    });
  }

  const initMiniCart = (parent) => {
    let cartEl = document.getElementById('cart');
    if (!cartEl) {
      let cart = document.createElement('div');
      cart.setAttribute("id", "cart");

      document.getElementById(parent).appendChild(cart);
      cartEl = document.getElementById('cart');
      setCartElement(cartEl);
    }
  }

  const initBackgroundImage = (src) => {
    // console.log('initBackgroundImage');
    document.getElementById('booking').style.backgroundImage = 'url(' + src + ')';
  }

  const setCSSVars = (d) => {
    // console.log('setCSSVars', d);
    const options = {
      '--main-font-family': d.main_font,
      '--title-font-family': d.title_font,
      '--button-font-family': d.button_font,
      '--accent-color': d.accent_color,
      '--secondary-color': d.secondary_color,
      '--ticket-color': d.ticket_button,
      '--avail-color': d.calendar_colors.available_color,
      '--selected-color': d.calendar_colors.selected_color,
      '--soldout-color': d.calendar_colors.sold_out_color,
      '--event1-color': d.event_colors.event_color1,
      '--event2-color': d.event_colors.event_color2,
      '--event3-color': d.event_colors.event_color3,
      '--event4-color': d.event_colors.event_color4,
      '--event5-color': d.event_colors.event_color5,
    };
    for (let [key, value] of Object.entries(options)) {
      document.documentElement.style.setProperty(key, value);
    }
  }

  return {
    cartElement,
    changeType,
    processContent
  }
}

export default useAppData;